<template>
  <div v-if="itemData.type != 'output'" class="col-sm-4">

    <!-- LABEL -->
    <label :for="itemData.uid" v-if="itemData.label && itemData.type != 'display-text' && itemData.type != 'heading'">{{ itemData.label }}</label>

    <!-- INPUTS -->
    <input
      v-model="answer"
      class="form-control client-form-control input-lg"
      type="text"
      v-if="itemData.type == 'text'"
      :placeholder="itemData.placeholder">

    <select
      v-model="answer"
      class="form-control client-form-control input-lg"
      v-if="itemData.type == 'select'">
      <option value="">--select--</option>
      <option :value="itm" v-for="(itm,idx) in itemData.options" :key="idx">{{ itm }}</option>
    </select>

    <textarea
      v-model="answer"
      class="form-control client-form-control input-lg"
      v-if="itemData.type == 'textarea'"
      :placeholder="itemData.placeholder"></textarea>

    <div v-if="itemData.type === 'radio'">
      <div
        class="radio"
        v-for="(itm,idx) in itemData.options" :key="idx">
        <label>
          <input
            v-model="answer"
            type="radio"
            :value="itm"
            :name="itemData.uid"> {{ itm }} <br>
        </label>
      </div>
    </div>

    <div v-if="itemData.type === 'checkbox'">
      <div
        class="checkbox-option"
        v-for="(itm,idx) in itemData.options"
        :key="idx">
        <label>
          <input
            type="checkbox"
            @click="handleCheckboxes($event, idx)"
            :data-name="itemData.name"
            :value="idx"
            :checked="Array.isArray(answer) && answer.includes(idx)"
            :name="itemData.uid"> {{ itm }} <br>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicEditItem',
  props: ['itemData', 'answers'],
  data () {
    return {
    }
  },
  computed: {
    answer: {
      get () {
        if (!this.answers.hasOwnProperty(this.itemData.uid)) {
          this.answers[this.itemData.uid] = ''
        }
        return this.answers[this.itemData.uid]
      },
      set (value) {
        this.answers[this.itemData.uid] = value
      }
    }
  },
  watch: {
    answer: {
      handler: 'saveAnswer',
      deep: true
    }
  },
  methods: {
    handleCheckboxes (e, idx) {
      let checked = e.target.checked

      if (!Array.isArray(this.answer)) {
        this.answer = []
      }

      if (checked) {
        this.answer.push(idx)
      } else {
        this.answer = _.remove(this.answer, function (a) { return a !== idx })
      }
    },
    saveAnswer () {
      this.$props.answers[this.$props.itemData.uid] = this.answer
      this.$emit('input', this.$props.answers)
    }
  }
}
</script>
